import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import cn from 'clsx'

// Components
import { Image } from '@tracklib/kit'

// Hooks
import { useSongs } from 'modules/entities/hooks'

// Selectors
import { selectTrackListFromTrackIds } from 'modules/browse/selectors'

// Types
import type { State, Loop } from 'types'

import styles from './covergrid.css'

type TrackId = { id: number; loop?: Loop | undefined }

type CoverGridProps = {
  mask: string
  trackIds: Array<TrackId>
}

const CoverGrid = ({ mask, trackIds }: CoverGridProps): JSX.Element => {
  const [covers, setCovers] = useState<Array<string>>([])
  const songs = useSongs()

  const uniqueSongIdsFromTrackIds = useSelector<State, Array<number>>((state): Array<number> => {
    const songIds = selectTrackListFromTrackIds(state, trackIds).map(x => x.songId)
    const uniqueSongIds = [...new Set(songIds)]
    return uniqueSongIds
  })
  const currentCovers = uniqueSongIdsFromTrackIds.map(songId => songs[String(songId)].cover)

  useEffect(() => {
    if (uniqueSongIdsFromTrackIds.length > covers.length) {
      setCovers(currentCovers)
    }
  }, [uniqueSongIdsFromTrackIds, covers, currentCovers])

  const getDisplayClassName = (): string => {
    const { length } = covers
    if (length === 1) {
      return ''
    } else if (length > 14) {
      return styles.sixteen
    } else if (length > 2) {
      return styles.four
    } else if (length > 1) {
      return styles.two
    } else {
      return styles.empty
    }
  }

  return (
    <div className={cn(styles.wrapper, mask === 'star' && styles.star, mask === 'disc' && styles.disc, getDisplayClassName())}>
      {covers.length ? (
        covers
          .filter((x, i) => (covers.length > 15 ? i < 16 : i < 4))
          .map((cover, i) => (
            <div className={styles.image} key={String(i)}>
              <Image image={cover} alt="" absolute sizes={covers.length > 1 ? '52px' : '105px'} />
            </div>
          ))
      ) : (
        <div className={styles.image} />
      )}
    </div>
  )
}

export default CoverGrid
